import { put } from 'redux-saga/effects';

import { store } from '../store';
import { send } from '../../helpers/requests';
import * as actions from './actions';
import { shouldFetchClients } from './utils';

import { ReduxStore } from '../../types/redux/state';
import { selectShowCustomer, selectToken } from '../selectors';

export function* getClientsRequestSaga(payload: any): Generator<any, void, any> {
  try {
    const _store: ReduxStore = store.getState();
    const showCustomer = selectShowCustomer(_store);
    if (!shouldFetchClients(_store.clients, showCustomer)) {
      yield put(actions.getClientsStopLoading());
      return;
    }
    const res = yield send({
      url: '/clients',
      method: 'GET',
      cache: 'default',
      token: selectToken(_store),
      params: payload.data,
    });
    yield put(actions.getClientsRequestSuccess({ res, showIntacctId: _store.userSettings.data.showIntacctId }));
  } catch (error) {
    yield put(actions.getClientsRequestFailure(error));
  }
}
